export var SqlEngineType;
(function (SqlEngineType) {
    SqlEngineType["SQL_ENGINE_TYPE_TRINO"] = "TRINO";
    SqlEngineType["SQL_ENGINE_TYPE_DATAFUSION"] = "DATAFUSION";
    SqlEngineType["SQL_ENGINE_TYPE_STARROCKS"] = "STARROCKS";
    SqlEngineType["SQL_ENGINE_TYPE_CLICKHOUSE"] = "CLICKHOUSE";
})(SqlEngineType || (SqlEngineType = {}));
